"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const menu_button_1 = require("@reach/menu-button");
require("@reach/menu-button/styles.css");
require("react");
require("../display-qr-button.types");
exports.Button = (0, theme_1.styled)(menu_button_1.MenuButton) `
  color: ${({ theme }) => theme.colors['on-accent'].primary};
  opacity: 1;
  height: ${(props) => `${props.buttonHeight || 56}px`};
  ${!theme_1.media.desktop} {
    width: 100%;
  }
  ${theme_1.media.desktop} {
    width: ${(props) => `${props.width || 248}px`};
    width: auto;
  }
  ${theme_1.mixins.flex({
    justifyContent: 'center',
    alignItems: 'center',
    inline: true,
})};
  ${theme_1.typography.medium18};
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius32) !== null && _a !== void 0 ? _a : theme.common.radius; }};
  border-width: 0px;
  cursor: pointer;
  box-sizing: border-box;
  padding: 16px 32px;
  background: ${({ buttonColor, theme }) => buttonColor || theme.colors.accent.action.normal};
  border-color: ${({ buttonColor, theme }) => buttonColor || theme.colors.accent.action.normal};

  &:hover {
    background-color: ${({ theme }) => theme.colors.accent.action.darkened};
    border-color: ${({ theme }) => theme.colors.accent.action.darkened};
  }
`;
